module.exports = __webpack_public_path__ + "img/toast-close.5858e62b.svg";